import React, { useEffect } from "react";
import { ExpressServiceIcon } from "../Icons";
import ReasonTypeSelectionCard from "./ReasonTypeSelectionCard";
import WellnessReasonIcon from "../Icons/WellnessReasonIcon";
import SickReasonsIcon from "../Icons/SickReasonsIcon";
import { REASON_CATEGORY } from "../../config/params";

interface IReasonTypeSelectionList{
  isExpressPresent?: boolean;
  handleSelection:(selectedReasonType : string) => void;
  selectedReasonType: string;
  hasSocData: boolean;
  petName: string;
}

const ReasonTypeSelectionList = ({
  isExpressPresent= true, handleSelection, selectedReasonType, hasSocData, petName,
}: IReasonTypeSelectionList) => {
  const handleCardSelection = (reasonType: string)=>{
    handleSelection(reasonType);
  };


  useEffect(()=>{
    switch (selectedReasonType) {
    case REASON_CATEGORY.WELLNESS:
      break;
    case REASON_CATEGORY.SICK:
      break;
    case REASON_CATEGORY.EXPRESS:
      break;
    default:
      break;
    }
  }, [selectedReasonType]);

  return (
    <div className="grid grid-cols-2 gap-3 w-full">
      <ReasonTypeSelectionCard
        isSelected={selectedReasonType===REASON_CATEGORY.WELLNESS}
        icon={<WellnessReasonIcon />}
        cardTitle={REASON_CATEGORY.WELLNESS}
        onClick={handleCardSelection}
        hasSocData={hasSocData}
        petName={petName}
      />
      <ReasonTypeSelectionCard
        isSelected={selectedReasonType===REASON_CATEGORY.SICK}
        icon={<SickReasonsIcon />}
        cardTitle={REASON_CATEGORY.SICK}
        onClick={handleCardSelection}
        petName={petName}
      />
      {isExpressPresent &&
        <ReasonTypeSelectionCard
          isSelected={selectedReasonType===REASON_CATEGORY.EXPRESS}
          icon={<ExpressServiceIcon />}
          cardTitle={REASON_CATEGORY.EXPRESS}
          onClick={handleCardSelection}
          petName={petName}
        />}
    </div>
  );
};

export default ReasonTypeSelectionList;
